import eopfS1Grd from './eopf-s1-grd'
import eopfS2L1c from './eopf-s2-l1c'
import eopfS2L2a from './eopf-s2-l2a'
import type { Dataset } from './types'

export { SELECTOR_SECTIONS } from './sections'

export const DATASETS: Dataset<any>[] = [eopfS1Grd, eopfS2L1c, eopfS2L2a]

export const DATASET_MAP = Object.fromEntries(
  DATASETS.map((d) => [d.id, d])
) as Record<string, Dataset>

export const DEFAULT_DATASET_ID = eopfS1Grd.id

export type { Dataset } from './types'
